<template>
  <section class="d-flex flex-lg-column flex-xs-row flex-xxs-column px-lg-4 px-xxs-4 pb-lg-5 pb-xxs-0">
    <h3 class="order-lg-1 order-xs-2 order-xxs-1 col-lg-12 col-xs-4 col-xxs-12 d-flex justify-content-center align-self-lg-center align-self-xxs-start mt-3 dir-ltr flex-basis-auto">
      @{{ user.Nickname }}
    </h3>
    <p class="order-lg-2 order-xs-1 order-xxs-2 mt-2 px-4 col-lg-12 col-xs-4 col-xxs-12 flex-basis-auto line-height-2">
      {{ user.Biography }}
    </p>
    <div class="order-3 col-lg-12 col-xs-4 col-xxs-12 flex-column mt-xxs-0 flex-basis-auto">
      <strong class="d-flex mt-3 flex-lg-row flex-xxs-row-reverse">
        <img height="22" src="@/assets/icons/id-card.svg" class="mx-2">
        {{ user.FirstName }} {{ user.LastName }}
      </strong>
      <strong class="d-flex mt-3 flex-lg-row flex-xxs-row-reverse">
        <img height="22" src="@/assets/icons/email.svg" class="mx-2">
        {{ user.Email }}
      </strong>
      <strong class="d-flex mt-3 flex-lg-row flex-xxs-row-reverse">
        <img height="22" src="@/assets/icons/phone.svg" class="mx-2 bidi-icon">
        {{ user.Cellphone }}
      </strong>
      <strong class="d-flex mt-3 flex-lg-row flex-xxs-row-reverse">
        <img height="22" src="@/assets/icons/DOB.svg" class="mx-2">
        {{ dateOfBirth }}
      </strong>
      <strong class="d-flex mt-3 flex-lg-row flex-xxs-row-reverse">
        <img height="22" src="@/assets/icons/gender.svg" class="mx-2">
        {{ user.Gender }}
      </strong>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'UserProfileDemographic',
  props: {
    user: Object
  },
  data () {
    return {
      dateOfBirth: ''
    }
  },
  watch: {
    user: function () {
      this.dateOfBirth = this.user.DateOfBirth ? (new persianDate(new Date(this.user.DateOfBirth)).format('L')) : ''
    }
  },
  mounted () {
    this.dateOfBirth = this.user.DateOfBirth ? (new persianDate(new Date(this.user.DateOfBirth)).format('L')) : ''
  }
  // created(){
  //   this.dateOfBirth = new persianDate(new Date(this.User.DateOfBirth)).format('L');
  // }
}
</script>
